module.exports = __webpack_public_path__ + "img/20180815_151844_201.ffe5c20e.jpg";